export const HDR_SKY_SWITCH = 'HDR_SKY_SWITCH';